import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
//import { v4 as uuidv4 } from 'uuid'; // Import the v4 function

//export interface ForSelectedDatesChange {
//  TID: number;
//  GetItemArrayStr: string;
//  YesDone: number;
//  // Add other properties as needed
//}

export interface StringArrayWrapper {
  // The property name (e.g., 'ids') should match the Web API model property name.
  GetItemArrayStr: string[];
  //NewDateTime: string;
  //YearCode: number;
}

@Injectable({
  providedIn: 'root'
})


export class FeecollectionService {

  readonly baseURL = sessionStorage.getItem('NbaseURLs');
  baseURL_2 = 'https://localhost:44386/api';

  constructor(private httpClient: HttpClient) { }
  //sessionStorage.setItem('Paymode', 'T');
  //      sessionStorage.setItem('Paymodestr', 'RGTS/IMPS/NEFT');
  getFeeCollectionDWise(forDate: Date, ShiftId: number, UserId: number): Observable<any> {
    debugger;
    sessionStorage.setItem('firstPrccoess', '2');
    return this.httpClient.get(this.baseURL + '/GetFeeCollectionDateWise?forDate=' + forDate + '&&ShiftId=' + ShiftId + '&&Paymodestr=' + sessionStorage.getItem('Paymodestr') + '&&ByBank=' + sessionStorage.getItem('Bank') + '&&UserId=' + UserId)
      .pipe(retry(1), catchError(this.handleError));    
  }

  getFeeCollectionDWiseZero(forDate: Date, ShiftId: number): Observable<any> {
    sessionStorage.setItem('firstPrccoess', '2');
    return this.httpClient.get(this.baseURL + '/GetFeeCollectionDateWiseZero?forDate=' + forDate + '&&ShiftId=' + ShiftId + '&&Paymodestr=' + sessionStorage.getItem('Paymodestr') + '&&ByBank=' + sessionStorage.getItem('Bank'))
      .pipe(retry(1), catchError(this.handleError));
  }

  spChangeDateUpdate(TrnNo: string, BankNo: string, DateChange: string, YearCode: number): Observable<any> {
    return this.httpClient.get<any>(this.baseURL + '/spChangeDateUpdate?TrnNo=' + TrnNo.toString() + '&&BankNo=' + BankNo.toString() + '&&DateChange=' + DateChange.toString() + '&&YearCode=' + YearCode + '&&IpAddressN=' + sessionStorage.getItem('ipaddress2').toString())
  }

  spChangeDateUpdateAll(fromDateChange: string, NewDateChange: string, YearCode: number): Observable<any> {
    return this.httpClient.get<any>(this.baseURL + '/spChangeDateUpdateAll?fromDateChange=' + fromDateChange.toString() + '&&NewDateChange=' + NewDateChange.toString() + '&&YearCode=' + YearCode + '&&IpAddressN=' + sessionStorage.getItem('ipaddress2').toString() + '&&UserCode=' + sessionStorage.getItem('usercode').toString())
  }

  spChangeDateSelected(fromDateChange: string, NewDateChange: string, YearCode: number, selectedDates: string[]): Observable<any> {
    debugger;
    const body: StringArrayWrapper = { GetItemArrayStr: selectedDates };
    return this.httpClient.post<any>(this.baseURL + '/SPChangeDateSelected?YearCode=' + YearCode + '&NewDateTime=' + NewDateChange, body);
    //let Ids = new HttpParams();
    //selectedDates.forEach((Id, i) => {
    //  //Ids = Ids.append('TID', Number(i + 1));
    //  Ids = Ids.append('GetItemArrayStr', Id);
    //  Ids = Ids.append('YesDone', 0);
    //});

    //console.log(Ids);
    //return this.httpClient.post<any>(this.baseURL + '/SPChangeDateSelected?NewDateChange=' + NewDateChange);
    //return this.httpClient.post<any>(this.baseURL + '/SPChangeDateSelected?', body);
    //return this.httpClient.get<any>(this.baseURL + '/spChangeDateSelected?fromDateChange=' + fromDateChange.toString() + '&&NewDateChange=' + NewDateChange.toString() + '&&YearCode=' + YearCode + '&&IpAddressN=' + sessionStorage.getItem('ipaddress2').toString() + '&&UserCode=' + sessionStorage.getItem('usercode').toString() + '&&params=' + params)
    //  .pipe(retry(1), catchError(this.handleError));
  }

  DeleteStudentFeeTran(MaxRNo: string, Yearcode: number, TrnNo: string)
  {
    return this.httpClient.delete(this.baseURL + '/DeleteStudentFeeTran?MaxRNo=' + MaxRNo + '&&Yearcode=' + Yearcode + '&&TrnNo=' + TrnNo);
  }

  handleError(error: any) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    // window.alert(errorMessage);
    return throwError(() => {
      return errorMessage;
    });
  }
}
